export const formatDate = (timestamp: number) => {
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear().toString();
  const month = "0" + (date.getMonth() + 1);
  const day = "0" + date.getDate();
  const hours = date.getHours();
  const minutes = "0" + date.getMinutes();
  const seconds = "0" + date.getSeconds();

  const formattedTime =
    year.substring(year.split("").length - 2) +
    month.substring(month.length - 2) +
    day.substring(day.length - 2) +
    " " +
    hours +
    ":" +
    minutes.substring(minutes.split("").length - 2);
  // ":" +
  // seconds.substring(seconds.split("").length - 2);
  return formattedTime;
};
